<template>
  <v-alert
    v-bind="$attrs"
    :value="alert"
    class="bm-headline"
    :type="type"
    :color="
      color || (theme.isDark() && type === 'error' ? 'errorMedium' : undefined)
    "
    @click="emit('click', $event)"
  >
    <slot />
    <template v-if="dismissible" #close>
      <div
        class="button"
        role="button"
        tabindex="0"
        @click="
          alert = false;
          emit('dismiss');
        "
      >
        <bm-icon icon="Close" data-qa="close_alert" :color="closeIconColour" />
      </div>
    </template>
    <template v-if="dismissible" #prepend>
      <slot name="prepend"></slot>
    </template>
  </v-alert>
</template>

<script setup lang="ts">
import { makeRef } from "@/components/composables/reactivityTypes";
import { theme } from "@/app/theme";

interface BmAlertProps {
  dismissible?: boolean;
  type?: string;
  color?: string;
  closeIconColour?: string;
}

interface BmAlertEvents {
  (event: "click", value: MouseEvent): void;
  (event: "dismiss"): void;
}

withDefaults(defineProps<BmAlertProps>(), {
  dismissible: false,
});

const emit = defineEmits<BmAlertEvents>();

const alert = makeRef(true);
</script>

<style lang="sass">
@import "src/sass/colours"

.v-alert
  color: white !important
  border-width: 3px
  align-items: flex-start

.v-alert.warning, .warningMedium
  color: $bm-color-text01 !important
  border-width: 3px

.v-alert .button
  cursor: pointer
  align-self: flex-start

.v-alert a
  color: white !important
  text-decoration: underline

.v-alert.warning a, .warningMedium a
  color: $bm-color-text01 !important

.v-alert
  word-break: normal
  overflow-wrap: anywhere
</style>
